import type { SidePanelSize } from "./side-panel.type";

import { SIDE_PANEL_SIZE } from "./side-panel.constant";

export const getSidePanelWidth = (size?: SidePanelSize) => {
  return size ? SIDE_PANEL_SIZE[size] : SIDE_PANEL_SIZE.default;
};
